<template>
    <el-dialog :append-to-body="true" :title="title" :visible.sync="visible" :before-close="close" :close-on-click-modal="false" class="fire-control-dialog">
        <el-form ref="formRef" :model="form" :rules="rules" label-width="200px">
            <el-form-item label="消防分区名称" prop="fireZoneName">
                <el-input v-model="form.fireZoneName"></el-input>
            </el-form-item>
            <el-form-item label="面积(四面墙内实际可用面积/㎡)" prop="fireZoneSquare">
                <el-input v-model="form.fireZoneSquare"></el-input>
            </el-form-item>
            <el-form-item label="裸租面积(㎡)" prop="nakedRentalArea">
                <el-input v-model="form.nakedRentalArea"></el-input>
            </el-form-item>
            <el-form-item label="合同状态" prop="fireZoneContractStatus">
                <mSelect optionNum="PHY_WH_CONTRACT_STATUS" :value="form.fireZoneContractStatus" :filterable="true" @input="propsChange"></mSelect>
            </el-form-item>
            <el-form-item label="当前是否可租" prop="enableLease">
                <mSelect optionNum="SRM_PHY_WH_ENABLE_LEASE" :value="form.enableLease" :filterable="true" @input="leaseChange"></mSelect>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="save">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { addFireZone, editFireZone } from '../../../../../api/addPhysicalStorage.js';
import mSelect from '../../../../../components/Select.vue';

const INTI_FORM = { fireZoneName: '', fireZoneSquare: '', nakedRentalArea: '', fireZoneContractStatus: '',enableLease: '' };
export default {
    name: 'fireControlDialog',
    components: { mSelect },
    data() {
        return {
            visible: false,
            loading: false,
            form: { ...INTI_FORM },
            rules: {
                fireZoneName: [{ required: true, message: '请输入消防分区名称', trigger: ['blur', 'change'] }],
                fireZoneSquare: [
                    { required: true, message: '请输入面积', trigger: ['blur', 'change'] },
                    {
                        validator(rule, value, callback) {
                            if (value && !/^\d{1,8}(\.\d{1,2})?$/.test(value)) {
                                callback(new Error('面积最多8位整数，保留两位小数!'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change']
                    }
                ],
                nakedRentalArea: [
                    {
                        validator: (rule, value, callback) => {
                            if (value && !/^\d{1,6}(\.\d{1,2})?$/.test(value)) {
                                callback(new Error('面积最多6位整数，保留两位小数!'));
                            } else if (value && Number(value) > Number(this.form.fireZoneSquare)) {
                                callback(new Error('裸租面积不能大于消防分区面积!'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change']
                    }
                ],
                fireZoneContractStatus: [{ required: true, message: '请选择合同状态', trigger: ['blur', 'change'] }],
                enableLease: [{ required: true, message: '请选择当前是否可租', trigger: ['blur', 'change'] }]
            },
            sonWhCode: null,
            id: null,
            version: null
        };
    },
    computed: {
        title() {
            return this.id ? '编辑消防分区' : '新增消防分区';
        },
        operate() {
            const obj = this.id ? { api: editFireZone, msg: '编辑成功' } : { api: addFireZone, msg: '新增成功' };
            return obj;
        }
    },
    methods: {
        openToAdd(sonWhCode) {
            this.sonWhCode = sonWhCode;
            this.id = null;
            this.visible = true;
        },
        openToEdit(row) {
            this.sonWhCode = row.sonWhCode;
            this.id = row.id;
            this.version = row.version;
            this.form = { fireZoneName: row.fireZoneName, fireZoneSquare: row.fireZoneSquare, nakedRentalArea: row.nakedRentalArea, fireZoneContractStatus: row.fireZoneContractStatus,enableLease: row.enableLease};
            this.visible = true;
        },
        close() {
            this.clear();
            this.visible = false;
        },
        save() {
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.operate.api(this.getParams()).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success(this.operate.msg);
                            this.$emit('refresh', this.sonWhCode);
                            this.close();
                        }
                    }).finally(() => { this.loading = false; });
                }
            });
        },
        clear() {
            // this.form = { ...INTI_FORM };
            this.$refs.formRef.resetFields();
        },
        // load() {},
        getParams() {
            const params = { ...this.form, sonWhCode: this.sonWhCode };
            if (this.id) {
                params.id = this.id;
                params.version = this.version;
            }
            return params;
        },
        propsChange(val) {
            this.form.fireZoneContractStatus = val;
        },
        // 当前是否可租
        leaseChange(val) {
            this.form.enableLease = val;
        }
    }
};
</script>
<style lang="less">
    .fire-control-dialog {
        .el-input {
            width: 70%;
        }
    }
</style>